if (!customElements.get("cart-reviews")) {
  let savedReviewsSliderState = {
    index: 0,
  };

  class CartReviewsSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      this.saveSliderState();
      this.destroySlider();
    }

    saveSliderState() {
      if (!this.swiper) return;
      savedReviewsSliderState = {
        index: this.swiper.activeIndex || 0,
      };
    }

    restoreSliderState() {
      if (!this.swiper) return;

      const maxIndex = Math.max(0, (this.swiper.slides?.length || 1) - 1);
      const safeIndex = Math.min(
        Math.max(0, savedReviewsSliderState.index || 0),
        maxIndex
      );

      requestAnimationFrame(() => {
        if (!this.swiper) return;
        this.swiper.slideTo(safeIndex, 0, false);
      });
    }

    initSlider() {
      const sliderEl = this.querySelector(".cart-reviews-slider");
      if (!sliderEl || typeof Swiper === "undefined") return;

      const nextEl = this.querySelector(".cart-reviews__arrow--next");
      const prevEl = this.querySelector(".cart-reviews__arrow--prev");
      const initialSlide = savedReviewsSliderState.index || 0;

      this.swiper = new Swiper(sliderEl, {
        slidesPerView: 1.15,
        spaceBetween: 12,
        initialSlide,
        watchOverflow: true,
        navigation: {
          nextEl,
          prevEl,
        },
        on: {
          init: () => this.restoreSliderState(),
        },
      });
    }

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define("cart-reviews", CartReviewsSlider);
}
